import { StateClassName } from './types';

export function detectStateClassName(
  has: boolean,
  force: boolean,
  state: boolean,
  className: Maybe<StateClassName>
): Maybe<StateClassName> {
  if (has && (force || state)) {
    return className;
  }

  return undefined;
}
